import { useInfiniteQuery, UseInfiniteQueryOptions, UseInfiniteQueryResult } from '@tanstack/react-query';

import { querySetsConfigs, QUERY_KEY } from 'src/queries/querySetsConfigs';

type PageResult = Models.PageResult<Models.IngestConfigApi.SetsConfigs.SetsConfigSummary>;
type QueryKey = App.SetsConfigs.QueryKey;

export const useInfiniteQuerySetsConfigs = (
    accessToken: string | undefined | false,
    search: App.SetsConfigs.PagedSearch,
    options?: UseInfiniteQueryOptions<PageResult, Error, PageResult, PageResult, QueryKey>,
): UseInfiniteQueryResult<PageResult, Error> => useInfiniteQuery<PageResult, Error, PageResult, QueryKey>(
    [QUERY_KEY, accessToken, search],
    querySetsConfigs,
    {
        ...options,
        getNextPageParam: (lastPage) => {
            const next = lastPage.offset + lastPage.limit;

            return next < lastPage.total ? next : undefined;
        },
    },
);
